// TEMPORARY: Braze push sync — remove when legacy facility app is sunset
import { registerPlugin } from "@capacitor/core";

interface BrazePushSyncPlugin {
  changeUser(options: { userId: string }): Promise<void>;
  registerPushToken(options: { token: string }): Promise<void>;
}

const BrazePushSync = registerPlugin<BrazePushSyncPlugin>("BrazePushSync");

export { BrazePushSync };
